import { Theme } from '@mui/material';
import { getTypographyVariants } from '@theme/styleOverrides/typography';

// FUTURE THEME TODO: get into style overrides so we can use
// font/line height increases
export const tablePagination = (theme: Theme) => ({
  borderBottom: 'none',
  '& .MuiSelect-select': {
    display: 'flex',
    justifyContent: 'center',
    minWidth: '55px',
    border: `1px solid gray`,
    borderColor: 'border.dark',
    borderRadius: '4px',
    ...getTypographyVariants(theme.palette.fontSize).bodySmall,
    '&:focus': {
      backgroundColor: 'transparent',
    },
  },
  '& .MuiTablePagination-toolbar': {
    paddingRight: '24px',
  },
  '& .MuiTablePagination-selectLabel': {
    ...getTypographyVariants(theme.palette.fontSize).bodySmall,
    color: theme.palette.theme === 'lio' ? 'common.black' : 'text.main',
  },
  '& .MuiTablePagination-displayedRows': {
    ...getTypographyVariants(theme.palette.fontSize).bodySmall,
    color: theme.palette.theme === 'lio' ? 'common.black' : 'text.main',
  },
});
